/** Remember one-time website credentials after Telegram login. */

const KEY = 'yp_website_creds_once';

export type OnceCredentials = {
  username: string;
  password: string;
};

export function rememberOnceCredentials(username: string, password: string): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ username, password }));
  } catch {
    /* ignore */
  }
}

export function peekOnceCredentials(): OnceCredentials | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as OnceCredentials;
    if (!parsed?.username || !parsed?.password) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearOnceCredentials(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export function captureWebsiteAccountFromAuth(data: {
  website_account?: { username?: string; password?: string | null; is_new?: boolean } | null;
} | undefined): void {
  const wa = data?.website_account;
  if (wa?.is_new && wa.username && wa.password) {
    rememberOnceCredentials(wa.username, wa.password);
  }
}
